/**
 * medi-elementor.js: site-wide Elementor behavior, loaded wherever Elementor renders.
 * Bundled by esbuild to static/medi-elementor.js.
 */
import { initElementor } from '../../features/elementor/elementor.js';

document.addEventListener('DOMContentLoaded', () => {
  initElementor();
});
